<template>
  <section>
    <h1>About Us</h1>
    <div class="card-band-styling">
      <h3>Our Message</h3>
      <div id="our-message-text">We are a tech start-up developing multi-sensory IoT devices with AI for Learning Disabilities and Motor Skills Impairment. We target the public & private schools, and health care institutions.</div>
    </div>
    <div class="card-band-styling">
      <h3>Attributions</h3>
      <h5>Icons</h5>
      <div id="icon-attributions-container">
        <div>Video by ClickHan from <a href="https://thenounproject.com/browse/icons/term/video/" target="_blank" title="Video Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Video Off by ClickHan from <a href="https://thenounproject.com/browse/icons/term/video-off/" target="_blank" title="Video Off Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>audio file by Xinh Studio from <a href="https://thenounproject.com/browse/icons/term/audio-file/" target="_blank" title="audio file Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Info Circle by Sari Braga from <a href="https://thenounproject.com/browse/icons/term/info-circle/" target="_blank" title="Info Circle Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>List Edit by Graphik Designz from <a href="https://thenounproject.com/browse/icons/term/list-edit/" target="_blank" title="List Edit Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>lightbulb by Maxim Kulikov from <a href="https://thenounproject.com/browse/icons/term/lightbulb/" target="_blank" title="lightbulb Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>mike by shashank singh from <a href="https://thenounproject.com/browse/icons/term/mike/" target="_blank" title="mike Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Camera by rukanicon from <a href="https://thenounproject.com/browse/icons/term/camera/" target="_blank" title="Camera Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>play by Humantech from <a href="https://thenounproject.com/browse/icons/term/play/" target="_blank" title="play Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Eye Tracking by Candy Design from <a href="https://thenounproject.com/browse/icons/term/eye-tracking/" target="_blank" title="Eye Tracking Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>analyzing by Adrien Coquet from <a href="https://thenounproject.com/browse/icons/term/analyzing/" target="_blank" title="analyzing Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>strong by Jackvisual assets from <a href="https://thenounproject.com/browse/icons/term/strong/" target="_blank" title="strong Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>heart pulse by Philipp Petzka from <a href="https://thenounproject.com/browse/icons/term/heart-pulse/" target="_blank" title="heart pulse Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Augmented Reality by KARNA RAJA from <a href="https://thenounproject.com/browse/icons/term/augmented-reality/" target="_blank" title="Augmented Reality Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Virtual Reality by Bharat from <a href="https://thenounproject.com/browse/icons/term/virtual-reality/" target="_blank" title="Virtual Reality Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Info by Marquet from <a href="https://thenounproject.com/browse/icons/term/info/" target="_blank" title="Info Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>question mark by Miroku Sama from <a href="https://thenounproject.com/browse/icons/term/question-mark/" target="_blank" title="question mark Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Rotate by Studio Paw from <a href="https://thenounproject.com/browse/icons/term/rotate/" target="_blank" title="Rotate Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>Next by Studio Paw from <a href="https://thenounproject.com/browse/icons/term/next/" target="_blank" title="Next Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>back by Studio Paw from <a href="https://thenounproject.com/browse/icons/term/back/" target="_blank" title="back Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>find result by joeartcon from <a href="https://thenounproject.com/browse/icons/term/find-result/" target="_blank" title="find result Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>bar chart by SUCI UTOMO from <a href="https://thenounproject.com/browse/icons/term/bar-chart/" target="_blank" title="bar chart Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>graduation by Revana Dera from <a href="https://thenounproject.com/browse/icons/term/graduation/" target="_blank" title="graduation Icons">Noun Project</a> (CC BY 3.0)</div>
        <div>lecture by Solomakhina Maria from <a href="https://thenounproject.com/browse/icons/term/lecture/" target="_blank" title="lecture Icons">Noun Project</a> (CC BY 3.0)</div>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>
<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  section {
    font-family: 'Roboto', sans-serif;
    color: #000000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h3 {
    text-align: center;
  }

  .card-band-styling {
    position: relative;
    width: 75%;
  }

  #icon-attributions-container {
    font-size: .7rem;
    margin-left: 2rem;
  }

  #our-message-text {
    font-size: 1rem;
  }

</style>